import type { DesignListItem } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { quoteRequestPath, storeCustomizeDesignPath } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

interface QuoteDesignActionsProps {
  readonly design: DesignListItem;
}

const ACTION_CLASS = 'h-10 flex-1 px-3 text-[13px]';

/**
 * 디자인 카드 버튼 — 견적 요청(/request/:designId)·수정(같은 디자인 덮어쓰기).
 * 판매 중이 아닌 상품의 디자인은 서버가 요청을 막으므로 버튼 대신 안내만 남긴다.
 */
export const QuoteDesignActions = ({ design }: QuoteDesignActionsProps): ReactElement => {
  if (design.productStatus !== 'PUBLISHED') {
    return <p className="text-xs text-muted-foreground">판매가 중지된 상품의 디자인입니다.</p>;
  }

  return (
    <div className="flex gap-2">
      <Link
        to={storeCustomizeDesignPath(design.productId, design.id)}
        aria-label={`${design.name} 수정`}
        className={cn(buttonVariants({ variant: 'outline' }), ACTION_CLASS, 'border-foreground/20')}
      >
        수정
      </Link>
      <Link
        to={quoteRequestPath(design.id)}
        aria-label={`${design.name} 견적 요청`}
        className={cn(buttonVariants(), ACTION_CLASS)}
      >
        견적 요청
      </Link>
    </div>
  );
};
